import React, { Component } from 'react'
import Details from './Details'
import Manpower from './Manpower'
import Solveny from './Solveny'
import Bankdetails from './Bankdetails'
import CAdetails from './CAdetails'
import Financial from './Financial'
import ContractWorklist from './Worklist'
import TabNav from './../TabNav';
import Tab from './../Tab';

class Contractor extends Component { 
    constructor(props){      
        super(props);   
        this.state = {
          selected: 'Basic Details'
        }  
      }  
      setSelected = (tab) => {
        this.setState({ selected: tab });
      }           
    render() { 
        return (
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
            Contractor
            </h1>
            <ol className="breadcrumb">
            <li><i className="fa fa-dashboard"></i> Home</li>
            <li className="active">Contractor</li>
            </ol>
          </section>
          <section className="content">
          <TabNav tabs={['Basic Details', 'Manpower Details', 'Solvency Details','Bank Details','CA Details','Financial Details','Work Details']} selected={ this.state.selected } setSelected={ this.setSelected }>
              <Tab isSelected={ this.state.selected === 'Basic Details' }>
                  <Details>{this.props.match.params.id}</Details>
              </Tab>
              <Tab isSelected={ this.state.selected === 'Manpower Details' }>
                  <Manpower>{this.props.match.params.id}</Manpower>
              </Tab>
              <Tab isSelected={ this.state.selected === 'Solvency Details' }>
                  <Solveny>{this.props.match.params.id}</Solveny>
              </Tab>
              <Tab isSelected={ this.state.selected === 'Bank Details' }>
                  <Bankdetails>{this.props.match.params.id}</Bankdetails>
              </Tab>              
              <Tab isSelected={ this.state.selected === 'CA Details' }>
                  <CAdetails>{this.props.match.params.id}</CAdetails>
              </Tab>
              <Tab isSelected={ this.state.selected === 'Financial Details' }>
                  <Financial>{this.props.match.params.id}</Financial>
              </Tab> 
              <Tab isSelected={ this.state.selected === 'Work Details' }>
                  <ContractWorklist>{this.props.match.params.id}</ContractWorklist>
              </Tab>               
            </TabNav>    
        </section>
        </div>        
        )
    }
}
export default Contractor